import AdminInstance from 'modules/admin/repository';

export const getWebhooks = (page, size, search, filters, sort) => AdminInstance.getWebhooks({
  page, size, search, filters, sort,
});

export const deleteWebhook = (id) => AdminInstance.deleteWebhook(id);
